export default __webpack_public_path__ + "static/media/bastion-ult.b8af96ec.mp3";